import { CircleOff, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  readonly title: string;
  readonly message?: string;
  readonly icon?: LucideIcon;
}

// Explicit empty state — a panel must never render blank. Used for no-data and error cases alike.
export const EmptyState = ({
  title,
  message,
  icon: Icon = CircleOff,
}: EmptyStateProps): ReactNode => (
  <div className="empty-state">
    <Icon className="icon" size={26} aria-hidden />
    <h4>{title}</h4>
    {message ? <p>{message}</p> : null}
  </div>
);
